import "./LaxAirportService.module.css";
import Header from "@/reusable_sections/Header";
import HeroAirportTransfer from "./sections/HeroAirportTransfer";
import ServiceDetails from "./sections/ServiceDetails";
import FleetShowcase from "./sections/FleetShowcase";
import BookYourTransfer from "./sections/BookYourTransfer";
import Footer from "@/reusable_sections/Footer";
export default function LaxAirportServicePage() {
  return <div>
      <Header />
      <HeroAirportTransfer />
      <ServiceDetails />
      <FleetShowcase />
      <BookYourTransfer />
      <Footer />
    </div>;
}